import { supabase } from '../../supabase/client';

export async function resolveWhatsAppConfig(brandId?: string, csId?: string): Promise<{ apiKey: string; device?: string } | null> {
    try {
        const { data: configs } = await supabase
            .from('wa_bot_configs')
            .select('*')
            .eq('isActive', true);

        if (!configs || configs.length === 0) return null;

        if (csId) {
            const csMatch = configs.find((c: any) => (c.assignedCsIds || []).includes(csId));
            if (csMatch) return { apiKey: csMatch.waba_token || '', device: csMatch.waba_phone_id || undefined };
        }
        if (brandId) {
            const brandMatch = configs.find((c: any) => c.brandId === brandId);
            if (brandMatch) return { apiKey: brandMatch.waba_token || '', device: brandMatch.waba_phone_id || undefined };
        }
        const firstActive = configs[0];
        if (firstActive) return { apiKey: firstActive.waba_token || '', device: firstActive.waba_phone_id || undefined };
        return null;
    } catch (error) {
        console.error('Error resolving WhatsApp config:', error);
        return null;
    }
}
